export interface BaseResource {
  id: unknown;
  attributes: {
    parentNodeId: string | null;
    [key: string]: unknown;
  };
}

export enum TreeBrowserEvent {
  CHANGE = 'change',
  INITIAL_LOAD = 'initialLoad',
}

export interface TreeBrowserEvents {
  [TreeBrowserEvent.CHANGE]: () => void;
  [TreeBrowserEvent.INITIAL_LOAD]: () => void;
}

export interface TreeBrowserNodeMeta {
  isExpanded?: boolean;
  hasLoaded?: boolean;
  isLoading?: boolean;
  isDeleting?: boolean;
  isLoadingMore?: boolean;
  isLoadMoreNode?: boolean;
  hasMore?: boolean;
  total?: number;
}

// Internal storage type (without depth - computed on demand)
export type StoredNode<T extends BaseResource> = T & {
  meta: TreeBrowserNodeMeta;
};

// Output type with computed depth for rendering
export type TreeBrowserNode<T extends BaseResource> = T & {
  meta: TreeBrowserNodeMeta & { depth: number };
};

export type TreeBrowserLoaderOptions = {
  offset?: number;
  limit?: number;
};

export interface TreeBrowserOptions<T extends BaseResource, U = T['id']> {
  rootNodeId: U;
  nodeLoader: (
    id: U,
    options?: TreeBrowserLoaderOptions,
  ) => Promise<{ items: T[]; hasMore: boolean; total?: number }>;
  parentIdMapper: (node: StoredNode<T>, value?: U) => U | T;
  hasChildrenMapper: (node: StoredNode<T>, value?: boolean) => boolean | T;
  pageSize?: number;
}
